var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CorporateNavigation", { attrs: { ActivePage: "dashboard" } }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 text-right align-self-end" },
                  [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "sanitizedHref",
                            rawName: "v-sanitizedHref",
                            value: `/#/enterprise-plan/settings/${_vm.workspaceId}/${_vm.strategyId}`,
                            expression:
                              "`/#/enterprise-plan/settings/${workspaceId}/${strategyId}`",
                          },
                        ],
                        staticClass: "btn btn-success",
                        staticStyle: { padding: "0.7em 2em" },
                      },
                      [_vm._v("Create plan")]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr", {
                staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-12" }, [
                  _c("div", [
                    _c(
                      "table",
                      { staticClass: "table table-bordered table-hover" },
                      [
                        _c("thead"),
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.rm.Scenarios, function (s) {
                            return _c("tr", { key: s.Id }, [
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.formatDate(s.CreatedDate))
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c("small", [
                                  _vm._v(_vm._s(_vm.formatTime(s.CreatedDate))),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "sanitizedHref",
                                        rawName: "v-sanitizedHref",
                                        value: `/#/enterprise-plan/portfolios/${_vm.workspaceId}/${_vm.strategyId}/${s.Id}`,
                                        expression:
                                          "`/#/enterprise-plan/portfolios/${workspaceId}/${strategyId}/${s.Id}`",
                                      },
                                    ],
                                  },
                                  [_vm._v(_vm._s(s.Name))]
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c("small", [_vm._v(_vm._s(s.Description))]),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.formatDate(s.PlanningStartDate)
                                    ) +
                                    " - " +
                                    _vm._s(_vm.formatDate(s.PlanningEndDate)) +
                                    "\n                                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(s.Portfolios) +
                                    "\n                                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("div", { staticClass: "dropdown" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-outline-secondary dropdown-toggle",
                                      attrs: {
                                        type: "button",
                                        "data-toggle": "dropdown",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                            Actions\n                                        "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-menu dropdown-menu-right",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "sanitizedHref",
                                              rawName: "v-sanitizedHref",
                                              value: `/#/enterprise-plan/portfolios/${_vm.workspaceId}/${_vm.strategyId}/${s.Id}`,
                                              expression:
                                                "`/#/enterprise-plan/portfolios/${workspaceId}/${strategyId}/${s.Id}`",
                                            },
                                          ],
                                          staticClass: "dropdown-item",
                                        },
                                        [_vm._v("View")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "sanitizedHref",
                                              rawName: "v-sanitizedHref",
                                              value: `/#/enterprise-plan/settings/${_vm.workspaceId}/${_vm.strategyId}/${s.Id}`,
                                              expression:
                                                "`/#/enterprise-plan/settings/${workspaceId}/${strategyId}/${s.Id}`",
                                            },
                                          ],
                                          staticClass: "dropdown-item",
                                        },
                                        [_vm._v("Settings")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleCloneCorporateScenarioCommand(
                                                s
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Clone")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "dropdown-divider",
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDeleteCorporateScenarioCommand(
                                                s.Id
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Delete")]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
            margin: "0",
          },
        },
        [_vm._v("Enterprise plans")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c(
          "th",
          { staticClass: "text-center", staticStyle: { width: "120px" } },
          [_vm._v("Created")]
        ),
        _vm._v(" "),
        _c("th", [_vm._v("Plan")]),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "text-center", staticStyle: { width: "240px" } },
          [_vm._v("Planning horizon")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "text-center", staticStyle: { width: "120px" } },
          [_vm._v("Portfolios")]
        ),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "120px" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }